module.exports = __webpack_public_path__ + "static/media/Arms.Icon.74b73177.svg";